var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,style:({fill: _vm.fillColor}),attrs:{"aria-hidden":"true"},on:{"mouseover":function($event){_vm.onHover = true},"mouseleave":function($event){_vm.onHover = false}}},[_c('use',{attrs:{"href":_vm.iconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }